import {
    Flex,
    Grid,
    Text,
} from '@chakra-ui/react';
import React, { useLayoutEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
    BlockHeader,
    RichText,
    useAppDispath,
    Image,
} from 'shared';
import { LeadSmallSection } from 'features';
// eslint-disable-next-line no-restricted-imports
import { Carousel } from 'shared/ui/Carousel';
import { Helmet } from 'react-helmet-async';
// eslint-disable-next-line no-restricted-imports
import { richTextToString } from 'shared/lib/richtext-to-string';
import { PortfolioEventPageActions, usePortfolioEventPageState } from '../../store';

export const PortfolioEventMain = () => {
    const { id } = useParams();
    const dispatch = useAppDispath();
    const { portfolioEvent, leadFormPdf } = usePortfolioEventPageState();

    useLayoutEffect(() => {
        if (id) dispatch(PortfolioEventPageActions.getPortfolioEventByUid({ uid: id }));
    }, [id]);

    return (
        <Flex
            flexDirection="column"
        >
            <Helmet>
                <title>{portfolioEvent?.name}</title>
                <meta name="description" content={richTextToString(portfolioEvent?.description)} />
                <meta property="og:title" content={portfolioEvent?.name} />
            </Helmet>
            <BlockHeader
                title={portfolioEvent?.name || ''}
                imageSrc={portfolioEvent?.images?.at(0)?.url || ''}
            />
            <Grid
                background="#000000"
            >
                <LeadSmallSection
                    title="ХОТИТЕ ТАКОЕ ЖЕ МЕРОПРИЯТИЕ?"
                    padding="2rem"
                    buttonText="Заказать звонок"
                    background="#000000"
                    maxWidth={{
                        base: '425px',
                        lg: '1280px',
                    }}
                    width="100%"
                    margin="0 auto"
                    pdfUrl={leadFormPdf?.url}
                />
            </Grid>
            <Grid
                templateColumns="1fr"
                background="white"
                padding="2rem"
                gap="1rem"
                maxWidth={{
                    base: '425px',
                    lg: '1280px',
                }}
                width="100%"
                margin="0 auto"
            >
                <Flex
                    flexDirection="column"
                    flex={2}
                    border="3px solid #E74C3C"
                    height="fit-content"
                    padding="1rem"
                >
                    <Text>
                        <strong>
                            Место проведения:
                        </strong>
                        {' '}
                        {portfolioEvent?.place}
                    </Text>
                    <Text>
                        <strong>
                            Формат:
                        </strong>
                        {' '}
                        {portfolioEvent?.format}
                    </Text>
                    <Text>
                        <strong>
                            Количество гостей:
                        </strong>
                        {' '}
                        {portfolioEvent?.guestsCount}
                    </Text>
                    <Text>
                        <strong>
                            Дата мероприятия:
                        </strong>
                        {' '}
                        {portfolioEvent?.date?.toLocaleDateString()}
                    </Text>
                    <Text>
                        <strong>
                            Организатор:
                        </strong>
                        {' '}
                        {portfolioEvent?.organizer}
                    </Text>
                    <RichText
                        marginTop="1rem"
                        fontSize="1rem"
                        content={portfolioEvent?.description}
                    />
                </Flex>
                <Carousel
                    maxWidth={{
                        base: '425px',
                        lg: '1280px',
                    }}
                    width="100%"
                    margin="0 auto"
                    background="white"
                    withDialog
                    items={portfolioEvent?.images?.map(({ url }) => (
                        <Image aspectRatio="2 / 1" width="100%" objectFit="cover" src={url} />
                    )) || []}
                />
            </Grid>
        </Flex>
    );
};
